import type { LookupByQueryRequest } from '@unifyapps/network/generated/models/lookupByQueryRequest';
import { LookupByQueryRequestType } from '@unifyapps/network/generated/models/lookupByQueryRequestType';

export const interfacePermissionsLookupByQueryRequest: LookupByQueryRequest = {
  type: LookupByQueryRequestType.ByQuery,
  lookupType: 'APPLICATION_USER_ENTITY_TYPE_PERMISSIONS',
};
